import React from 'react';
export type StickerPreviewProps = {
        imagePreview: string | null;
        stickerName: string | null;
}


export default function StickerPreview(props: StickerPreviewProps) {

    if (!props.imagePreview) {
        return null;
    }

    return (
        <div className='flex w-full justify-center'>
            <img src={props.imagePreview} alt="Image preview" width='320px' className='rounded-xl shadow-sm'/>
        </div>
    )
}
